module.exports = {
      id: "video-icon-usage",
      viewBox: "0 0 92 92",
      url: "/" + "sprite-5d017f3fe034ec5d98a70bae909b913a.svg#video-icon",
      toString: function () {
        return this.url;
      }
    }